import type { StyleId, AspectRatio } from '@/lib/constants'
import type { ReferenceImage } from '@/types/generation'

export type QueueItemStatus = 'pending' | 'processing' | 'completed' | 'failed'

/** 큐 아이템 생성 파라미터 (스냅샷) */
export interface QueueItemParams {
  prompt: string
  style: StyleId
  aspectRatio: AspectRatio
  count: number
  referenceImages: ReferenceImage[]
  templateId?: string
  templateInfo?: {
    id: string
    name: string
    description: string | null
    thumbnailUrl: string | null
    nameI18n?: Record<string, string> | null
    descriptionI18n?: Record<string, string> | null
  }
}

/** 생성 큐 아이템 */
export interface QueueItem {
  /** 클라이언트 측 고유 ID (UUID) */
  id: string
  /** 생성 파라미터 스냅샷 */
  params: QueueItemParams
  /** 현재 상태 */
  status: QueueItemStatus
  /** 진행률 (0-100) */
  progress: number
  /** 진행 메시지의 i18n 키 (예: 'queue.analyzing'). 렌더 시점에 t()로 번역되어 언어 전환에 즉시 반응한다 */
  progressKey: string
  /** 큐에 추가된 시각 (timestamp) */
  createdAt: number
  /** 완료 시각 (timestamp) */
  completedAt?: number
  /** 에러 메시지 */
  error?: string
  /** 완료 후 백엔드 generation ID */
  generationId?: string
}

/** 큐 최대 개수 (1 processing + 4 pending) */
export const QUEUE_MAX_SIZE = 5
